<template>
    <div id="app">
        <component v-bind:is="layout"></component>
    </div>
</template>

<style lang="scss" scoped>
</style>

<script>
    import {mapGetters} from 'vuex';
    import {globalStoreMethods} from './global-store';

    export default {
        name: 'App',

        components: {
            'layout-login': () => import('./components/layout/layout-login'),
            'layout-standard': () => import('./components/layout/layout-standard'),
            'layout-empty': () => import('./components/layout/layout-empty')
        },

        computed: {

            ...mapGetters([
                globalStoreMethods.getters.layout
            ])

        }

    }
</script>